// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import checkoutSharedStyles from "@awc/App/SharedStyles/CheckoutSharedStyles";
import { checkoutShippingAddressesStyles } from "@awc/Overrides/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

const sharedAddressesStyle: any = {
    container: {
        gap: 0,
        offsetCss: css`
            ${checkoutSharedStyles.sectionInnerContainer?.css}
        `,
    },
    saveWrapper: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 20px;
            ${xScreen("lte", "sm")} {
                justify-content: center;
            }
        `,
    },
    saveButton: {
        css: css`
            min-width: 60%;
        `,
    },
    change: {
        typography: {
            size: fontConfig.fontSize.regular,
            lineHeight: fontConfig.lineHeight.singleLineRegular,
        },
        css: css`
            margin-top: 12px;
            ${TypographyStyle} {
                font-size: ${fontConfig.fontSize.regular}px;
                line-height: ${fontConfig.lineHeight.singleLineRegular};
            }
        `,
    },
    selectSavedAddressLink: {
        css: css`
            margin-left: 0;
        `,
    },
};

checkoutShippingAddressesStyles.billingAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
checkoutShippingAddressesStyles.shippingAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
checkoutShippingAddressesStyles.sectionTitle = {
    ...checkoutSharedStyles.sectionTitle,
};
checkoutShippingAddressesStyles.container = {
    gap: 24,
};
checkoutShippingAddressesStyles.billingAddress = {
    ...sharedAddressesStyle,
    manageSubscriptionsCheckbox: {
        mergeCss: true,
        css: css`
            label {
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.xSmall};
                font-weight: ${fontConfig.weight.bold};
                color: ${color("text")};
            }
            margin-top: 12px;
        `,
    },
};
checkoutShippingAddressesStyles.pickUpAddress = {
    container: {
        gap: 0,
        offsetCss: css`
            ${checkoutSharedStyles.sectionInnerContainer?.css}
        `,
    },
    headingGridItem: {
        css: css`
            display: none;
        `,
    },
};
checkoutShippingAddressesStyles.shippingAddress = {
    ...sharedAddressesStyle,
    headingGridItem: {
        css: css`
            padding-bottom: 12px;
            &:empty {
                display: none;
            }
        `,
    },
    oneTimeAddressGridItem: {
        css: css`
            padding-bottom: 12px;
            &:empty {
                display: none;
            }
        `,
    },
};
